import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import { ROLE_LABEL } from "@/components/TeamUsersCard";

export const REPORT_ROLES = ["admin", "oversight", "platinum", "team_leader", "leader"];

const melbYm = (d) => new Intl.DateTimeFormat("en-CA", { timeZone: "Australia/Melbourne", year: "numeric", month: "2-digit" })
  .format(d).slice(0, 7);
export const melbCurrentMonth = () => melbYm(new Date());
export function melbMonths(n = 24) {
  const [y, m] = melbCurrentMonth().split("-").map(Number);
  return Array.from({ length: n }, (_, i) => {
    const d = new Date(Date.UTC(y, m - 1 - i, 15));
    return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
  });
}

export const fmtMelb = (iso) => {
  if (!iso) return null;
  const d = iso.length === 10 ? new Date(`${iso}T12:00:00`) : new Date(iso);
  return d.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric", timeZone: "Australia/Melbourne" });
};

export function Chip({ active, onClick, children, testid }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid} aria-pressed={active}
            className={`h-8 px-3 rounded-full text-xs font-medium border whitespace-nowrap shrink-0 transition-colors ${active
              ? "bg-[#0A1F44] text-white border-[#0A1F44]" : "bg-white text-[#0A1F44] border-slate-200 hover:border-[#C9A961]"}`}>
      {children}
    </button>
  );
}

export function PersonRow({ u, canViewAs, onViewAs, lead, children, prefix }) {
  return (
    <div className="flex items-start gap-3 py-3" data-testid={`${prefix}-row-${u.id}`}>
      {lead}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <Link to={`/people/${u.id}`} data-testid={`${prefix}-profile-${u.id}`}
                className="text-sm font-medium text-slate-900 truncate hover:text-[#8A6D1F] hover:underline">{u.name}</Link>
          <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-[#0A1F44]/5 text-[#0A1F44]">
            {ROLE_LABEL[u.role] || u.role}
          </span>
        </div>
        <div className="text-[11px] text-slate-500 truncate mt-0.5">{u.upline_team || "No team"}</div>
        {children}
      </div>
      {canViewAs && (
        <button onClick={() => onViewAs(u)} data-testid={`${prefix}-view-as-${u.id}`} title={`View as ${u.name} (read only)`}
                className="w-9 h-9 shrink-0 rounded-full border border-slate-200 text-[#0A1F44] flex items-center justify-center hover:border-[#C9A961] hover:bg-[#C9A961]/10 transition-colors">
          <Eye className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}

export function ListShell({ rows, empty, testid, children }) {
  return (
    <div className="max-h-[30rem] sm:max-h-[26rem] overflow-y-auto overscroll-contain -mx-1 px-1 divide-y divide-slate-100"
         data-testid={testid} tabIndex={0}>
      {rows === null && <div className="text-sm text-slate-400 py-4">Loading…</div>}
      {rows && rows.length === 0 && <div className="text-sm text-slate-500 py-4" data-testid={`${testid}-empty`}>{empty}</div>}
      {children}
    </div>
  );
}

export const matches = (u, q) => {
  const s = q.trim().toLowerCase();
  return !s || [u.name, u.upline_team, ROLE_LABEL[u.role]].some((v) => (v || "").toLowerCase().includes(s));
};
